import script from "./data.vue?vue&type=script&setup=true&lang=js"
export * from "./data.vue?vue&type=script&setup=true&lang=js"

import "./data.vue?vue&type=style&index=0&id=41d60e82&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41d60e82"]])

export default __exports__